/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatrixCareAdmissionDemographics } from './MatrixCareAdmissionDemographics';
import {
    MatrixCareAdmissionDemographicsFromJSON,
    MatrixCareAdmissionDemographicsFromJSONTyped,
    MatrixCareAdmissionDemographicsToJSON,
    MatrixCareAdmissionDemographicsToJSONTyped,
} from './MatrixCareAdmissionDemographics';

/**
 * 
 * @export
 * @interface FindOneMatrixCareHomeHealthAdmissionDemographics200Response
 */
export interface FindOneMatrixCareHomeHealthAdmissionDemographics200Response {
    /**
     * 
     */
    data?: MatrixCareAdmissionDemographics;
}

/**
 * Check if a given object implements the FindOneMatrixCareHomeHealthAdmissionDemographics200Response interface.
 */
export function instanceOfFindOneMatrixCareHomeHealthAdmissionDemographics200Response(value: object): value is FindOneMatrixCareHomeHealthAdmissionDemographics200Response {
    return true;
}

export function FindOneMatrixCareHomeHealthAdmissionDemographics200ResponseFromJSON(json: any): FindOneMatrixCareHomeHealthAdmissionDemographics200Response {
    return FindOneMatrixCareHomeHealthAdmissionDemographics200ResponseFromJSONTyped(json, false);
}

export function FindOneMatrixCareHomeHealthAdmissionDemographics200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOneMatrixCareHomeHealthAdmissionDemographics200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : MatrixCareAdmissionDemographicsFromJSON(json['data']),
    };
}

export function FindOneMatrixCareHomeHealthAdmissionDemographics200ResponseToJSON(json: any): FindOneMatrixCareHomeHealthAdmissionDemographics200Response {
    return FindOneMatrixCareHomeHealthAdmissionDemographics200ResponseToJSONTyped(json, false);
}

export function FindOneMatrixCareHomeHealthAdmissionDemographics200ResponseToJSONTyped(value?: FindOneMatrixCareHomeHealthAdmissionDemographics200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': MatrixCareAdmissionDemographicsToJSON(value['data']),
    };
}

